import { api } from "@/utils/api";
import { Link, useNavigate } from "react-router-dom";
import { navigateFullPage } from "@/utils/fullPageNavigation";
import { loginUser } from "../../../../features/user/userSlice";
import { useDispatch } from "react-redux";
import { useRef, useState } from "react";
import { toast } from "@/utils/appToast";
import { JandiSymbol } from "@/components/assets/logos/svgs";

const FormContent = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigation = useNavigate();
  const closeModalBtn = useRef();
  const dispatch = useDispatch();

  const handleLogIn = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const loginForm = e.target as HTMLFormElement;
    const btn = closeModalBtn.current as HTMLButtonElement;

    const closeModal = () => {
      btn.click();
    };

    const loginData = new FormData(loginForm);

    setIsLoading(true);
    const { status, data } = await api.signIn({
      email: loginData.get("email") as string,
      password: loginData.get("password") as string,
    });
    setIsLoading(false);

    if (status === "error") {
      toast.error(data.message);
      return;
    }

    const { token, user } = data;
    dispatch(loginUser({ token, user }));

    if (user.type === "worker") {
     const redirected = await checkWorkerProfile(); // ✅ wait for result
    if (redirected) return;
    }

    loginForm.reset();
    closeModal();

    window.location.assign("/servicios");
  };

  const checkWorkerProfile = async () => {
    const workerProfile = await api.getMyWorkerProfile();
    const isStripeOnBoardingCompleted = workerProfile?.isStripeOnBoardingCompleted
    if(!isStripeOnBoardingCompleted){
       const onboardingLink = await api.getAccountLink()
       console.log("onboardinglink ,",onboardingLink)
       window.location.href = onboardingLink;
       return true;
    }
    const hasSkills = workerProfile.skills.length > 0;

    if (
      !hasSkills ||
      !workerProfile.hourlyPay ||
      !workerProfile.maxDistance ||
      !workerProfile.description
    ) {
      navigation("/update-worker");
    } else {
      navigation("/dashboard");
    }
  };

  return (
    <div className="form-inner">
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 20,
          marginTop: 20,
        }}
      >
        {/* <JandiSymbol alt /> */}
        <img
                      src="/images/phone_symbol.svg" 
                      alt="Phone Symbol" 
                      style={{ 
                        width: '60px', 
                        height: '60px',
                        display: 'block'
                      }} 
                    />
      </div>

      <h3 style={{ color: "white", fontWeight: 600 }}>Jandi - Ingresar</h3>

      {/* Hidden Button to Close Modal */}
      <button className="d-none" data-bs-dismiss="modal" ref={closeModalBtn}>
        Close modal
      </button>

      {/* <!--Login Form--> */}
      <form method="post" onSubmit={handleLogIn}>
        <div className="form-group">
          <label style={{ color: "white" }}>
            Correo Electronico de Usuario
          </label>
          <input
            style={{ borderRadius: 0 }}
            type="email"
            name="email"
            placeholder="Email"
            required
          />
        </div>
        {/* email */}

        <div className="form-group">
          <label style={{ color: "white" }}>Contraseña</label>
          <input
            style={{ borderRadius: 0 }}
            type="password"
            name="password"
            placeholder="Contraseña"
            required
          />
        </div>
        {/* password */}

        <div className="form-group">
          <div className="field-outer">
            <div className="input-group checkboxes square">
              <input type="checkbox" name="remember-me" id="remember" />
              <label
                htmlFor="remember"
                className="remember"
                style={{ color: "white" }}
              >
                <span className="custom-checkbox"></span> Recuérdame
              </label>
            </div>
            <a 
              style={{ color: "white" }} 
              href="#" 
              className="pwd"
              data-bs-toggle="modal"
              data-bs-target="#forgotPasswordModal"
            >
              ¿Has olvidado tu contraseña?
            </a>
          </div>
        </div>
        {/* forgot password */}

        <div className="form-group">
          <button
            className="theme-btn btn-style-one"
            type="submit"
            name="log-in"
            disabled={isLoading}
            style={{ backgroundColor: "black" }}
          >
            {isLoading ? (
              <div
                className="spinner-border"
                style={{ height: "15px", width: "15px" }}
                role="status"
              ></div>
            ) : (
              "Iniciar Sesión"
            )}
          </button>
        </div>
        {/* login */}
      </form>
      {/* End form */}

      <div className="bottom-box">
        <div className="text" style={{ color: "white" }}>
          ¿No tienes cuenta?{" "}
          <Link
            to="#"
            className="call-modal signup"
            data-bs-toggle="modal"
            data-bs-target="#registerModal"
            style={{ color: "white" }}
          >
            Registrate
          </Link>
        </div>

        {/* <div className="divider">
          <span>or</span>
        </div> */}

        {/* <LoginWithSocial /> */}
      </div>
      {/* End bottom-box LoginWithSocial */}
    </div>
  );
};

export default FormContent;
